import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const createStyle = (color?: string) => {
    return makeStyles({
        common: {
            position: 'absolute',
            backgroundColor: color
        },
        lineTop: {
            top: '-3%',
            left: '45%',
            width: '10%',
            height: '58%',
        },
        lineLeft: {
            top: '45%',
            left: '-3%',
            width: '53%',
            height: '10%'
        },
        lineBottom: {
            top: '45%',
            left: '45%',
            width: '10%',
            height: '58%'
        },
        lineRight: {
            top: '45%',
            left: '50%',
            width: '53%',
            height: '10%',
        }
    })
}

export interface LineProps {
    rowDifference: number
    columnDifference: number
    color: string
}

export const Line = React.memo((props: LineProps): JSX.Element => {
    const { rowDifference, columnDifference, color } = props
    const useStyles = React.useCallback(createStyle(color), [color])
    const classes = useStyles()
    let lineStyle: string = ''

    if (rowDifference === 0) {
        if (columnDifference === 1) {
            lineStyle = classes.lineLeft
        } else if (columnDifference === -1) {
            lineStyle = classes.lineRight
        }
    } else if (rowDifference === 1) {
        lineStyle = classes.lineTop
    } else if (rowDifference === -1) {
        lineStyle = classes.lineBottom
    }

    return <div className={clsx(classes.common, lineStyle)} />
})
